export default __webpack_public_path__ + "static/media/person01-3x.22052add.png";